export default __webpack_public_path__ + "static/media/file-large.99266a26.svg";